import type { IconDefinition } from "@fortawesome/fontawesome-common-types";
import { faInstagram } from "@fortawesome/free-brands-svg-icons/faInstagram";
import { faBars } from "@fortawesome/pro-light-svg-icons/faBars";
import { faBook } from "@fortawesome/pro-light-svg-icons/faBook";
import { faBrush } from "@fortawesome/pro-light-svg-icons/faBrush";
import { faCalculator } from "@fortawesome/pro-light-svg-icons/faCalculator";
import { faCalendarXmark } from "@fortawesome/pro-light-svg-icons/faCalendarXmark";
import { faCheck } from "@fortawesome/pro-light-svg-icons/faCheck";
import { faChevronCircleLeft } from "@fortawesome/pro-light-svg-icons/faChevronCircleLeft";
import { faChevronCircleRight } from "@fortawesome/pro-light-svg-icons/faChevronCircleRight";
import { faCircle } from "@fortawesome/pro-light-svg-icons/faCircle";
import { faCircleCheck } from "@fortawesome/pro-light-svg-icons/faCircleCheck";
import { faCirclePlus } from "@fortawesome/pro-light-svg-icons/faCirclePlus";
import { faCircleUser } from "@fortawesome/pro-light-svg-icons/faCircleUser";
import { faCircleXmark } from "@fortawesome/pro-light-svg-icons/faCircleXmark";
import { faClipboardList } from "@fortawesome/pro-light-svg-icons/faClipboardList";
import { faEnvelope } from "@fortawesome/pro-light-svg-icons/faEnvelope";
import { faExclamationTriangle } from "@fortawesome/pro-light-svg-icons/faExclamationTriangle";
import { faFileUpload } from "@fortawesome/pro-light-svg-icons/faFileUpload";
import { faFlag } from "@fortawesome/pro-light-svg-icons/faFlag";
import { faHandshake } from "@fortawesome/pro-light-svg-icons/faHandshake";
import { faHeart } from "@fortawesome/pro-light-svg-icons/faHeart";
import { faHourglass } from "@fortawesome/pro-light-svg-icons/faHourglass";
import { faHouse } from "@fortawesome/pro-light-svg-icons/faHouse";
import { faImage } from "@fortawesome/pro-light-svg-icons/faImage";
import { faLeaf } from "@fortawesome/pro-light-svg-icons/faLeaf";
import { faLightbulb } from "@fortawesome/pro-light-svg-icons/faLightbulb";
import { faLock } from "@fortawesome/pro-light-svg-icons/faLock";
import { faNewspaper } from "@fortawesome/pro-light-svg-icons/faNewspaper";
import { faPallet } from "@fortawesome/pro-light-svg-icons/faPallet";
import { faPalette } from "@fortawesome/pro-light-svg-icons/faPalette";
import { faPartyHorn } from "@fortawesome/pro-light-svg-icons/faPartyHorn";
import { faPencil } from "@fortawesome/pro-light-svg-icons/faPencil";
import { faPhone } from "@fortawesome/pro-light-svg-icons/faPhone";
import { faQuestion } from "@fortawesome/pro-light-svg-icons/faQuestion";
import { faSearch } from "@fortawesome/pro-light-svg-icons/faSearch";
import { faSeedling } from "@fortawesome/pro-light-svg-icons/faSeedling";
import { faShoppingBag } from "@fortawesome/pro-light-svg-icons/faShoppingBag";
import { faShovel } from "@fortawesome/pro-light-svg-icons/faShovel";
import { faSparkles } from "@fortawesome/pro-light-svg-icons/faSparkles";
import { faStar } from "@fortawesome/pro-light-svg-icons/faStar";
import { faStopwatch } from "@fortawesome/pro-light-svg-icons/faStopwatch";
import { faTimes } from "@fortawesome/pro-light-svg-icons/faTimes";
import { faTrashAlt } from "@fortawesome/pro-light-svg-icons/faTrashAlt";
import { faUser } from "@fortawesome/pro-light-svg-icons/faUser";
import { faXmark } from "@fortawesome/pro-light-svg-icons/faXmark";
import {
  FontAwesomeIcon,
  FontAwesomeIconProps,
} from "@fortawesome/react-fontawesome";
import { FC } from "react";

export type FaIconComponentProps = Omit<FontAwesomeIconProps, "icon">;

function createFaIconComponent(icon: IconDefinition): FC<FaIconComponentProps> {
  return function (props: FaIconComponentProps) {
    return <FontAwesomeIcon icon={icon} {...props} size={props.size || "1x"} />;
  };
}

export const FaIcon = (function () {
  const faIcon = {
    faHourglass,
    faTrashAlt,
    faFileUpload,
    faCheck,
    faCircle,
    faCircleXmark,
    faClipboardList,
    faFlag,
    faHeart,
    faExclamationTriangle,
    faCircleCheck,
    faXmark,
    faBars,
    faCircleUser,
    faCalculator,
    faTimes,
    faSearch,
    faPhone,
    faInstagram,
    faImage,
    faLeaf,
    faHandshake,
    faLightbulb,
    faNewspaper,
    faStar,
    faShoppingBag,
    faQuestion,
    faSparkles,
    faPallet,
    faShovel,
    faBook,
    faSeedling,
    faPencil,
    faUser,
    faChevronCircleLeft,
    faChevronCircleRight,
    faCalendarXmark,
    faPartyHorn,
    faStopwatch,
    faLock,
    faHouse,
    faPalette,
    faBrush,
    faCirclePlus,
    faEnvelope,
  } as const;

  type FontAwesomeIconComponents = {
    [Property in keyof typeof faIcon]: FC<FaIconComponentProps>;
  };

  const iconComponents: Record<string, FC<FaIconComponentProps>> = {};

  for (const key in faIcon) {
    iconComponents[key] = createFaIconComponent(
      faIcon[key as keyof typeof faIcon],
    );
  }
  return iconComponents as FontAwesomeIconComponents;
})();
